import React, { useEffect, useState } from "react";

import axios from "../../../config/axiosConfig";
import { CustomTable } from "../../../Component/UI/Table";
import { Edit } from "../../../assets/icons/Edit";
import { Report } from "../../../assets/icons/Report";
import { to12Hours, YtoD } from "../../../config/formattedDate";
import { Link } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilter,
  setFrom_date,
  setSearch_key,
  setTo_date,
  setClear,
} from "../../../Redux/Slices/AdminFilters/Search";
import OnlineImg from "../../../assets/images/appOnline.svg";
import OfflineImg from "../../../assets/images/appOffline.svg";
import HybirdImg from "../../../assets/images/appHybird.svg";
import moment from "../../../../node_modules/moment/moment";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { CircularProgress } from "../../../../node_modules/@mui/material/index";
export const CompletedAppointment = ({ setCompletedData }) => {
  const [client, setClient] = useState([]);
  const [loadingApp, setLoadingApp] = useState(false);
  const dispatch = useDispatch();
  const { search_key, from_date, to_date, filter } = useSelector(
    (i) => i.SearchFilters
  );

  
     const [completedappointment,setCompletedAppointment] = useState([])
     const newdta = useSelector((state)=>state?.rolesAndPermissions)
       useEffect(()=>{
          const rolesAndPerms = newdta?.data?.access_role?.permission ?? '[]'
          const ifRoleNameBlank = JSON.parse(rolesAndPerms);
          const permissionData = ifRoleNameBlank && ifRoleNameBlank?.categories?.[4]?.listControl?.fields
          const filedkey =  Object.keys(permissionData || {}).filter(
            key => permissionData[key]?.checked === 1
          );
          setCompletedAppointment(filedkey)
        },[newdta])
        

  const tHead = [
    ...completedappointment,
    // "Patient Name",
    // "Mobile",
    // "Date",
    // "Appointment ID",
    // "Staff",
    "Started At",
    "Completed At",
  ];

  const clientStatus = async (appointment_id, status) => {
    await axios
      .post("/admin/appointment/status/change", {
        appointment_id,
        status,
      })
      .then((res) => console.log(res))
      .catch((err) => console.error(err));
  };

  const handleDelete = async (appointment_id) => {
    await axios
      .post("/admin/appointment/status/change", {
        params: {
          appointment_id,
          status: 2,
        },
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    setLoadingApp(true);
    axios
      .get(
        `/admin/get/appointmentNew?type=completed&search_key=${search_key}&fromdate=${from_date !== "Invalid date" ? from_date : ''}&todate=${to_date !== "Invalid date" ? to_date : ''}`
      )
      .then((res) => {
        setLoadingApp(false);
        setClient(res.data.list);
      })
      .catch((err) => console.log(err));
  }, [filter]);

  useEffect(() => {
    setCompletedData(client);
  }, [client]);

  useEffect(() => {
    return () => {
      // dispatch(setSearch_key(""));
      // dispatch(setTo_date(""));
      // dispatch(setFrom_date(""));
      // dispatch(setFilter());
      // dispatch(setClear());
    };
  }, []);

  const tBodyData = client.map(
    (
      {
        paitient_name,
        mobile,
        appointment_date,
        session_id,
        service_type,
        appointment_time,
        status,
        id,
        staff,
        report,
        end_time,
        appointment_start_date,
        appointment_end_date,
        service_name,
      },
      index
    ) => {
      const appointmentDate = appointment_date.split("-").reverse();
      const appointment = [
        appointmentDate[0],
        appointmentDate[1],
        appointmentDate[2],
      ].join("-");
      const appointmentDate1 = appointment;

      const date = YtoD(appointment_date.split(" ")[0]);

      const [start_hour, start_min] = appointment_time.split(":");
      const [end_hour, end_min] = end_time.split(":");
      const time =
        to12Hours(start_hour, start_min) + " - " + to12Hours(end_hour, end_min);
      return {
        ...(completedappointment.includes('Patient Name') &&{
          paitient_name,
        }),
        ...(completedappointment.includes('Mobile') &&{
          mobile,
        }),
        ...(completedappointment.includes('Date') &&{
                  appointment_date: appointment_date
                  ? moment(appointment_date).format("DD-MM-YYYY")
                  : "",
                }),

                ...(completedappointment.includes('Appointment ID')&&{          

        session: (
          <>
            <div
              id={"AppointmentID" + index}
              style={{ display: "flex", flexDirection: "row" }}
            >
              <span>
                {" "}
                {service_type === 0 ? (
                  <img
                    style={{
                      width: "17px",
                      marginTop: "1px",
                      marginRight: "3px",
                    }}
                    src={OfflineImg}
                    alt={"Offline"}
                  />
                ) : service_type === 1 ? (
                  <img
                    style={{
                      width: "17px",
                      marginTop: "1px",
                      marginRight: "3px",
                    }}
                    src={OnlineImg}
                    alt={"Online"}
                  />
                ) : service_type === 2 ? (
                  <img
                    style={{
                      width: "17px",
                      marginTop: "1px",
                      marginRight: "3px",
                    }}
                    src={HybirdImg}
                    alt={"Hybird"}
                  />
                ) : (
                  ""
                )}
              </span>
              <span style={{ color: "#0085FF", textDecoration: "underline" }}>
                {session_id?.toUpperCase()}
              </span>
            </div>
            <ReactTooltip
              anchorId={"AppointmentID" + index}
              place="bottom"
              //variant="info"
              content={service_name}
            />
          </>
        ),
      }),

      ...(completedappointment.includes('Time')&&{          
        time,
          }),
       
    ...(completedappointment.includes('Staff')&&{          
        staff,
          }),

          startedAt: appointment_start_date
          ? moment(appointment_start_date).format("h:mm:ss A")
          : "",
        completedAt: appointment_end_date
          ? moment(appointment_end_date).format("h:mm:ss A")
          : "",
        // report,
        // action: (
        //   <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        //     <Link
        //       to={`user/appointments`}
        //       style={{ textDecoration: "none" }}
        //       state={{ data: client[index] }}
        //     >
        //       {/* <Edit /> */}
        //       <AiOutlineEye size={24} style={{ color: "gray" }} />
        //     </Link>

        //     <div
        //       style={{ color: "black", cursor: "pointer" }}
        //       onClick={() => handleDelete(id)}
        //     >
        //       <Report />
        //     </div>
        //   </div>
        // ),
      };
    }
  );

  return !loadingApp ? (
    <CustomTable tHead={tHead} tBody={tBodyData} />
  ) : (
    <div className="loader" style={{ textAlign: "center", margin: "60px" }}>
      <CircularProgress size={28} />
    </div>
  );
};
